const TOKEN_KEY = 'crm_access_token';
const REFRESH_KEY = 'crm_refresh_token';

/**
 * Get the stored access token.
 */
export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * Get the stored refresh token.
 */
export function getRefreshToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(REFRESH_KEY);
}

/**
 * Store authentication tokens.
 */
export function setTokens(accessToken: string, refreshToken: string): void {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
}

/**
 * Clear stored tokens (logout).
 */
export function clearTokens(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

/**
 * Check if user has stored tokens.
 */
export function hasTokens(): boolean {
  return !!getAccessToken();
}

/**
 * Parse JWT payload without verification.
 * Only use for reading claims, not for security decisions.
 */
export function parseToken(token: string): Record<string, unknown> | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * Check if token is expired.
 */
export function isTokenExpired(token: string): boolean {
  const payload = parseToken(token);
  if (!payload || typeof payload.exp !== 'number') return true;
  
  // Add 10 second buffer
  return Date.now() >= (payload.exp * 1000) - 10000;
}
